import { Common } from '@thecvlb/design-system/lib/src';

import { BasicSignupStepProps } from 'containers/SignUp/Content/content.types';

import { FlowTypes } from 'utils/enums';

import Image from 'assets/images/wm/wl-result.webp';

const MarketingRatedNumberOneForGLP: React.FC<BasicSignupStepProps> = ({
  moveToStep,
  selectedFlow
}) => {
  return (
    <div className="mx-auto flex h-full max-w-[500px] flex-col items-center md:gap-6">
      <div className="flex flex-col gap-6 max-md:mb-6 md:gap-6">
        <div>
          <h1 className="text-center text-m2xl text-primary-700 md:text-2xl">
            LifeMD is <b>rated #1</b> in the United States <br /> for GLP-1 Medication Access
          </h1>
          <p className="mt-2 text-center font-bold text-primary-700 md:font-semibold">
            How does LifeMD ensure the highest quality of medication?
          </p>
          <p className="mt-2 text-center text-primary-700">
            We have established partnerships with the leading GLP-1 compounding pharmacies in the
            United States, renowned for their reliability and excellence. Every ingredient we use is
            carefully sourced from FDA-approved suppliers, guaranteeing the same active ingredient
            quality as in Zepbound® and Wegovy®. To maintain our commitment to excellence, each
            batch of our medication is subjected to rigorous quality checks, ensuring unparalleled
            standards for our customers.
          </p>
        </div>
        <img alt="" src={Image} />
        {selectedFlow !== FlowTypes.BlueLineFlow &&
          selectedFlow !== FlowTypes.WeightManagementBalladHealth && (
            <Common.Alert type="info" colorableBackground>
              LifeMD will check your coverage eligibility for GLP-1 medications if you have
              insurance. If your out-of-pocket cost is high, LifeMD offers compounded medication
              options starting as little as $13 per week. If there is a change in your insurance,
              you can switch to branded medication at no additional subscription cost.
            </Common.Alert>
          )}
      </div>
      <Common.Button
        className="max-md:mt-auto"
        color="blue"
        fullWidthOnMobile
        onClick={() => moveToStep('next')}
      >
        Continue
      </Common.Button>
      <p className="max-w-[80%] text-center text-mSm font-semibold text-primary max-md:mt-2 md:text-base">
        Complete the signup process as soon as possible to secure your spot for an online
        consultation.
      </p>
    </div>
  );
};

export default MarketingRatedNumberOneForGLP;
